export const SEE_ORIGINAL_PRICE = 'See original price';
export const SEE_INTERNAL_NOTES = 'See internal notes';

export interface Permission {
    name: string;
}